import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import LoadingData from "../../TESTPage/LoadingData";
import { GetCookieToken } from "../../Cookie/GetCookie";
import axios from "axios";
import Lottie from "react-lottie";
import * as loadingLeaveSumary from "../../../assets/lottieAnimation/loadingLeaveSumary.json";
import { ConvertDate } from "../../Function/ConvertDate";

const ModalSummaryLeaveDay = ({
  modalSummaryLeaveDay,
  toggleModalSummaryLeaveDay,
  departMent,
  budGetYear,
  userId,
  dmyStart,
  dmyEnd,
  userEmployeeTypeId,
  orgId,
}) => {
  const [buttonLoading, setButtonLoading] = useState(false);
  const token = GetCookieToken("userToken");
  const [chunkThTd, setChunkThTd] = useState();
  const [chunkThTdPage, setChunkThTdPage] = useState();
  const [leaveDataAll, setLeaveDataAll] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allarray, setAllarray] = useState(null);
  const baseURL = process.env.REACT_APP_API_CORS;
  const [docxData, setDocxData] = useState(null)

  const pdfRef = useRef();

  const downloadPDF = async () => {
    setButtonLoading(true);
    const pdf = new jsPDF("l", "mm", "a4", true); //แนวนอน
    // const pdf = new jsPDF("", "mm", "a4", true); //แนวตั้ง
    const input = pdfRef.current;

    // ตรวจสอบว่า input ไม่เป็น null และถูกโหลดเรียบร้อยแล้ว
    if (input && input.childNodes.length > 0) {
      let maxLoop = input.childNodes.length;

      const marginX = 10; // กำหนดค่า margin ทางซ้ายและขวา
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const usableWidth = pdfWidth - marginX * 2; // คำนวณความกว้างที่ใช้งานได้หลังจากหัก margin ทั้งสองด้าน

      for (let i = 0; i < maxLoop; i++) {
        const element = input.childNodes[i];
        if (element instanceof HTMLElement) {
          const canvass = await html2canvas(element, { scale: 2 });
          const imgWidth = canvass.width;
          const imgHeight = canvass.height;
          const imgData = canvass.toDataURL("image/png");
          const ratio = Math.min(usableWidth / imgWidth); // ปรับอัตราส่วนตามความกว้างที่ใช้งานได้

          const imgX = marginX; // กำหนดค่า margin ทางซ้าย

          const adjustedImgWidth = imgWidth * ratio; // ปรับความกว้างของภาพใหม่
          const imgY = 5;

          if (i > 0) {
            pdf.addPage();
          }

          pdf.addImage(
            imgData,
            "PNG",
            imgX,
            imgY,
            adjustedImgWidth,
            imgHeight * ratio
          );
        } else {
          console.error("Invalid child node at index:", i);
        }
      }

      pdf.save("สรุปวันลาของข้าราชการและลูกจ้าง.pdf");
    } else {
      console.error("Input element is null or has no child nodes");
    }
    setButtonLoading(false);
  };

  const downloadDocx = async (reportType,leaveDataId, leaveName =null) => {
    try {
      setButtonLoading(true);
      const response = await axios.post(
        `${baseURL}/api/report/leaveSummary/docx`,docxData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: 'blob',
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `สรุปวันลาของข้าราชการและลูกจ้าง.docx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Error:', error);
    }
    setButtonLoading(false);
  };

  const leaveSummaryHistoryStatusUnique = async () => {
    let convertedDateStringFrom;
    let convertedDateStringTo;
    try {
      if (dmyStart) {
        const originalDateFrom = new Date(dmyStart);
        convertedDateStringFrom = originalDateFrom.toISOString();
      }
      if (dmyEnd) {
        const originalDateTo = new Date(dmyEnd);
        convertedDateStringTo = originalDateTo.toISOString();
      }

      const url = baseURL + "/api/report/leave/summary";
      const data = {};

      data.budget_year = budGetYear;

      if (userId) data.user_id = userId;
      if (convertedDateStringFrom) data.dmy_start = convertedDateStringFrom;
      if (convertedDateStringTo) data.dmy_end = convertedDateStringTo;
      if (userEmployeeTypeId) data.user_employee_type_id = userEmployeeTypeId;

      if (orgId) {
        data.org_id = orgId;
      } else if (departMent) {
        data.org_id = departMent;
      }
      const res = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      await setDocxData(data)
      await setLeaveDataAll(res?.data.result);
      await setLoading(true);
    } 
    catch (err) {
      // console.log("Error : ", err);
    }
  };

  const chunkArray = (arr, size) => {
    return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) => arr.slice(i * size, i * size + size));
  };

  const getLengthChunkArray = (arr, size) => {
    return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) => arr.slice(i * size, i * size + size)).length;
  };

  useEffect(() => {
    if (modalSummaryLeaveDay === true) {
        leaveSummaryHistoryStatusUnique()
    }
  }, [modalSummaryLeaveDay]);

  useEffect(() => {
    if (loading) {
      setChunkThTd(chunkArray(leaveDataAll, 10));
      setChunkThTdPage(getLengthChunkArray(leaveDataAll, 10));
    }
  }, [leaveDataAll, loading]);

  const exitModal = () => {
    setChunkThTdPage();
    setChunkThTd();
    setLoading(false);
    setLeaveDataAll([]);
    setAllarray(null);
    toggleModalSummaryLeaveDay();
  };

  return (
    <Modal size="xl" centered isOpen={modalSummaryLeaveDay} toggle={exitModal}>
      <ModalHeader toggle={exitModal}></ModalHeader>
      <ModalBody style={{ overflowX: "scroll"}}>
        <div>
          <div
            // id="pdf-container"
            ref={pdfRef}
            style={{
              fontFamily: "Sarabun,serif",
              visibility: "visible",
              minWidth:"1106px"
            }}
            className="w-100"
          >
            {loading === false && (
              <div>
                <Lottie
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData: loadingLeaveSumary.default,
                    rendererSettings: {
                      preserveAspectRatio: "xMidYMid slice",
                    },
                  }}
                  width={200}
                  height={200}
                />
              </div>
            )}
            {loading === true &&
              chunkThTd &&
              chunkThTd.map((leavedata, idx) => {
                return (
                  <Fragment key={idx}>
                    <div>
                      <Row className="my-2">
                        <Col
                          xxl={{
                            offset: 3,
                            size: 9,
                          }}
                          className="d-flex justify-content-end"
                        >
                          <b className="font-size-16">
                            หน้าที่ {idx + 1} / {chunkThTdPage}
                          </b>
                        </Col>
                      </Row>
                      <h4 className="text-center fw-semibold">
                        สรุปวันลาของเจ้าหน้าที่
                      </h4>
                      {dmyStart && dmyEnd &&
                        <h4 className="text-center fw-semibold">
                          วันที่ {ConvertDate(dmyStart).toThaiDateFullDMY()} ถึง {ConvertDate(dmyEnd).toThaiDateFullDMY()}
                        </h4>
                      }
                      <h4 className="text-center fw-semibold">
                        ปีงบประมาณ พ.ศ. {budGetYear}{" "}
                      </h4>

                      <Table>
                        <thead style={{ whiteSpace: "normal" }}>
                          <tr>
                            <th className="text-start ps-1" style={{ background: "#F8F6E3", verticalAlign: "middle"}}>เจ้าหน้าที่</th>
                            <th className="p-1 text-center" style={{ background: "#6699AA", verticalAlign: "middle"}} > ป </th>
                            <th className="p-1 text-center" style={{ background: "#FFFF88", verticalAlign: "middle"}} > ก </th>
                            <th className="p-1 text-center" style={{ background: "#88BBAA", verticalAlign: "middle"}} > ค </th>
                            <th className="p-1 text-center" style={{ background: "#000000", color: "white", verticalAlign: "middle"}} > พ </th>
                            <th className="p-1 text-center" style={{ background: "#d6b4ff", verticalAlign: "middle"}} > ต </th>
                            <th className="p-1 text-center" style={{ background: "#FFBE7D", verticalAlign: "middle"}}  colSpan={3}> ฮ </th>
                            <th className="p-1 text-center" style={{ background: "#B9E3AE", verticalAlign: "middle"}} > ศ </th>
                            <th className="p-1 text-center" style={{ background: "#BACAB3", verticalAlign: "middle"}} > ม </th>
                            <th className="p-1 text-center" style={{ background: "#CBAB8D", verticalAlign: "middle"}} > ปร </th>
                            <th className="p-1 text-center" style={{ background: "#6af3e0", verticalAlign: "middle"}} > ร </th>
                            <th className="p-1 text-center" style={{ background: "#FB9AD1", verticalAlign: "middle"}} > บ </th>
                            <th className="p-1 text-center" style={{ background: "#88BBDD", verticalAlign: "middle"}} > ข </th>
                            <th className="p-1 text-center" style={{ background: "#FF9797", verticalAlign: "middle"}} > ส </th>
                          </tr>
                        </thead>
                        <tbody>
                          {leavedata.length > 0 ? (
                            leavedata.map((item, idx) => {
                              let count = 0;
                              let countlate = 0;

                              if (item?.history?.length > 0) {
                                item.history.map(subItem => {
                                  if (subItem.entry_exit_status === 4 || subItem.note.trim() === "ไม่ลงเวลาออกงาน") {
                                    count++;
                                  }
                                  if (subItem.late === 1 || subItem.late === 2 || subItem.late === 3) {
                                    countlate++;
                                  }
                                });
                              }

                              return (
                                <tr>
                                  <td
                                    className="text-start ps-1"
                                  >
                                    {item.user_name}
                                  </td>
                                  <td className="text-center">
                                    {item.leave_counting?.length > 0
                                      ? item.leave_counting?.find(
                                          i => i.leave_type_id === 1
                                        )?.sum_leave_days || 0
                                      : 0}
                                  </td>
                                  <td className="text-center">
                                    {item.leave_counting?.length > 0
                                      ? item.leave_counting?.find(
                                          i => i.leave_type_id === 2
                                        )?.sum_leave_days || 0
                                      : 0}
                                  </td>
                                  <td className="text-center">
                                    {item.leave_counting?.length > 0
                                      ? item.leave_counting?.find(
                                          i => i.leave_type_id === 3
                                        )?.sum_leave_days || 0
                                      : 0}
                                  </td>
                                  <td className="text-center">
                                    {item.leave_counting?.length > 0
                                      ? item.leave_counting?.find(
                                          i => i.leave_type_id === 4
                                        )?.sum_leave_days || 0
                                      : 0}
                                  </td>
                                  <td className="text-center">
                                    {item.leave_counting?.length > 0
                                      ? item.leave_counting?.find(
                                          i => i.leave_type_id === 5
                                        )?.sum_leave_days || 0
                                      : 0}
                                  </td>
                                  <td className="text-center">
                                    {item.leave_counting?.length > 0
                                      ? item.leave_counting?.find(
                                          i => i.leave_type_id === 8
                                        )?.sum_leave_days || 0
                                      : 0}
                                  </td>
                                  <td className="text-center">
                                    {item.leave_counting?.length > 0
                                      ? item.leave_counting?.find(
                                          i => i.leave_type_id === 7
                                        )?.sum_leave_days || 0
                                      : 0}
                                  </td>
                                  <td className="text-center">
                                    {item.leave_counting?.length > 0
                                      ? item.leave_counting?.find(
                                          i => i.leave_type_id === 6
                                        )?.sum_leave_days || 0
                                      : 0}
                                  </td>
                                  <td className="text-center">
                                    {item.leave_counting?.length > 0
                                      ? item.leave_counting?.find(
                                          i => i.leave_type_id === 9
                                        )?.sum_leave_days || 0
                                      : 0}
                                  </td>
                                  <td className="text-center">
                                    {item.leave_counting?.length > 0
                                      ? item.leave_counting?.find(
                                          i => i.leave_type_id === 10
                                        )?.sum_leave_days || 0
                                      : 0}
                                  </td>
                                  <td className="text-center">
                                    {item.leave_counting?.length > 0
                                      ? item.leave_counting?.find(
                                          i => i.leave_type_id === 11
                                        )?.sum_leave_days || 0
                                      : 0}
                                  </td>
                                  <td className="text-center">
                                    {item.leave_counting?.length > 0
                                      ? item.leave_counting?.find(
                                          i => i.leave_type_id === 12
                                        )?.sum_leave_days || 0
                                      : 0}
                                  </td>
                                  <td className="text-center">
                                    {item.leave_counting?.length > 0
                                      ? item.leave_counting?.find(
                                          i => i.leave_type_id === 13
                                        )?.sum_leave_days || 0
                                      : 0}
                                  </td>
                                  <td className="text-center">{count}</td>
                                  <td className="text-center">{countlate}</td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="16" className="text-center fs-5">
                                ไม่มีข้อมูล
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </Fragment>
                );
              })}
            <Row className="my-2">
                <Col xs={6} lg={6} xxl={6}>
                  <Row>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 className="modal-card-h4" style={{ background: "#6699AA" }}> ป </h4>
                        <h5 className="m-0">ป่วย</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3}>
                      <div className="modal-card-leave">
                        <h4 className="modal-card-h4" style={{ background: "#FFFF88" }}> ก </h4>
                        <h5 className="m-0">ลากิจ</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 className="modal-card-h4" style={{ background: "#FF9797" }}> ส </h4>
                        <h5 className="m-0">สาย</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 className="modal-card-h4" style={{ background: "#88BBDD" }}> ข </h4>
                        <h5 className="m-0">ขาด/ไม่ลงเวลาออก</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 className="modal-card-h4" style={{ background: "#000", color: "white" }}> พ </h4>
                        <h5 className="m-0">พักผ่อน</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 style={{ background: "#CBAB8D" }} className="modal-card-h4"> ปร </h4>
                        <h5 className="m-0">ไปปฏิบัติราชการ</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 style={{ background: "#88BBAA" }} className="modal-card-h4"> ค </h4>
                        <h5 className="m-0">คลอด</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 style={{ background: "#B9E3AE", paddingRight: "17.5px" }} className="modal-card-h4"> ศ </h4>
                        <h5 className="m-0">ศึกษา/อบรม/ดูงาน</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 style={{ background: "#BACAB3", paddingRight: "19px" }} className="modal-card-h4"> ม </h4>
                        <h5 className="m-0">ติดตามคู่สมรส</h5>
                      </div>
                    </Col>
                    <Col xs={6} lg={6} xl={6} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 style={{ background: "#FFBE7D" }} className="modal-card-h4"> ฮ </h4>
                        <h5 className="m-0">เตรียมพล/พิธีฮัจญ์/อุปสมบท</h5>
                      </div>
                    </Col>
                    <Col xs={6} lg={6} xl={6} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 style={{ background: "#6af3e0" }} className="modal-card-h4"> ร </h4>
                        <h5 className="m-0">รับรองการมาปฏิบัติราชการ</h5>
                      </div>
                    </Col>
                    <Col xs={6} lg={6} xl={6} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 style={{ background: "#FB9AD1" }} className="modal-card-h4"> บ </h4>
                        <h5 className="m-0">เลี้ยงดูบุตร</h5>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="danger"
          onClick={() => {downloadPDF()}}
          disabled={buttonLoading}
        >
          {buttonLoading === true ? (
            <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
          ) : (
            <i className="fa-solid fa-file-pdf pe-2"></i>
          )}
          ดาวน์โหลด pdf
        </Button>
        <Button
          // className="mt-2 "
          color="success"
          onClick={() => {downloadDocx()}}
          disabled={buttonLoading}
        >
          {buttonLoading === true ? (
            <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
          ) : (
            <i className="fa-solid fa-file-doc pe-2"></i>
          )}
          ดาวน์โหลด docx
        </Button>
        <Button
          color="danger"
          onClick={() => {
            toggleModalSummaryLeaveDay();
            setButtonLoading(false);
          }}
        >
          ปิด
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalSummaryLeaveDay;
